import {
  createRouter,
  createWebHistory
} from 'vue-router';
import Home from '../views/Home.vue';
import Login from '../views/Login.vue';
import Ready from '../views/Ready';
import Race from '../views/Race';
import Inventory from '../views/Inventory.vue';
import MarketPlace from '../views/MarketPlace.vue';
import Details from '../views/Details.vue';
import MarketDetails from '../views/MarketDetails.vue';
import LeaderBoard from '../views/LeaderBoard.vue';
import Discover from '../views/Discover.vue';
import Battle from '../views/Battle.vue';
import Attack from '../views/Attack.vue';
import Waiting from '../views/Waiting.vue';
import Continent from '../views/Continent.vue';
import ApiService from '../services';
import mainView from '../components/Main';
import Staking from '../views/Staking.vue';
import LoginLayout from '../components/LoginLayout';
const routes = [{
    path: '/',
    redirect: '/dashboard',
    component: mainView,
    // dashboard auth guard
    beforeEnter(to, from, next) {
      if (!isLogin()) {
        next('/login');
      } else {
        next();
      }
    },
    children: [{
      path: '/dashboard',
      name: 'dashboard',
      props: true,
      component: Home,
      meta: {
        sideBarKey: 'Dashboard',
      },
    }, ],
  },
  {
    path: '/ready',
    component: mainView,
    // dashboard auth guard
    beforeEnter(to, from, next) {
      if (!isLogin()) {
        next('/login');
      } else {
        next();
      }
    },
    children: [{
      path: '/ready',
      name: 'ready',
      component: Ready,
      meta: {
        sideBarKey: 'ready',
      },
    }, ],
  },
  {
    path: '/race',
    component: mainView,
    // dashboard auth guard
    beforeEnter(to, from, next) {
      if (!isLogin()) {
        next('/login');
      } else {
        next();
      }
    },
    children: [{
      path: '/race',
      name: 'race',
      component: Race,
      meta: {
        sideBarKey: 'race',
      },
    }, ],
  },
  {
    path: '/inventory',
    component: mainView,
    // dashboard auth guard
    beforeEnter(to, from, next) {
      if (!isLogin()) {
        next('/login');
      } else {
        next();
      }
    },
    children: [{
      path: '/inventory',
      name: 'inventory',
      component: Inventory,
      meta: {
        sideBarKey: 'inventory',
      },
    }, ],
  },
  {
    path: '/marketPlace',
    component: mainView,
    // dashboard auth guard
    beforeEnter(to, from, next) {
      if (!isLogin()) {
        next('/login');
      } else {
        next();
      }
    },
    children: [{
      path: '/marketPlace',
      name: 'marketPlace',
      component: MarketPlace,
      meta: {
        sideBarKey: 'marketPlace',
      },
    }, ],
  },
  {
    path: '/marketDetails',
    component: mainView,
    // dashboard auth guard
    beforeEnter(to, from, next) {
      if (!isLogin()) {
        next('/login');
      } else {
        next();
      }
    },
    children: [{
      path: '/marketDetails/:id?',
      name: 'marketDetails',
      component: MarketDetails,
      meta: {
        sideBarKey: 'marketDetails',
      },
    }, ],
  },
  {
    path: '/details',
    component: mainView,
    // dashboard auth guard
    beforeEnter(to, from, next) {
      if (!isLogin()) {
        next('/login');
      } else {
        next();
      }
    },
    children: [{
      path: '/details/:id?',
      name: 'details',
      component: Details,
      meta: {
        sideBarKey: 'details',
      },
    }, ],
  },
  {
    path: '/discover',
    component: mainView,
    // dashboard auth guard
    beforeEnter(to, from, next) {
      if (!isLogin()) {
        next('/login');
      } else {
        next();
      }
    },
    children: [{
      path: '/discover',
      name: 'discover',
      component: Discover,
      meta: {
        sideBarKey: 'discover',
      },
    }, ],
  },
  {
    path: '/battle',
    component: mainView,
    // dashboard auth guard
    beforeEnter(to, from, next) {
      if (!isLogin()) {
        next('/login');
      } else {
        next();
      }
    },
    children: [{
      path: '/battle',
      name: 'battle',
      component: Battle,
      meta: {
        sideBarKey: 'battle',
      },
    }, ],
  },
  {
    path: '/attack',
    component: mainView,
    // dashboard auth guard
    beforeEnter(to, from, next) {
      if (!isLogin()) {
        next('/login');
      } else {
        next();
      }
    },
    children: [{
      path: '/attack',
      name: 'attack',
      component: Attack,
      meta: {
        sideBarKey: 'attack',
      },
    }, ],
  },
  {
    path: '/waiting',
    component: mainView,
    // dashboard auth guard
    beforeEnter(to, from, next) {
      if (!isLogin()) {
        next('/login');
      } else {
        next();
      }
    },
    children: [{
      path: '/waiting',
      name: 'waiting',
      component: Waiting,
      meta: {
        sideBarKey: 'waiting',
      },
    }, ],
  },
  {
    path: '/continent',
    component: mainView,
    // dashboard auth guard
    beforeEnter(to, from, next) {
      if (!isLogin()) {
        next('/login');
      } else {
        next();
      }
    },
    children: [{
      path: '/continent',
      name: 'continent',
      component: Continent,
      meta: {
        sideBarKey: 'continent',
      },
    }, ],
  },
  {
    path: '/leaderBoard',
    component: mainView,
    // dashboard auth guard
    beforeEnter(to, from, next) {
      if (!isLogin()) {
        next('/login');
      } else {
        next();
      }
    },
    children: [{
      path: '/leaderBoard',
      name: 'leaderBoard',
      component: LeaderBoard,
      meta: {
        sideBarKey: 'leaderBoard',
      },
    }, ],
  },
  {
    path: '/staking',
    component: mainView,
    // dashboard auth guard
    beforeEnter(to, from, next) {
      if (!isLogin()) {
        next('/login');
      } else {
        next();
      }
    },
    children: [{
      path: '/staking',
      name: 'staking',
      component: Staking,
      meta: {
        sideBarKey: 'staking',
      },
    }, ],
  },
  {
    path: '/login',
    component: LoginLayout,
    children: [{
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        sideBarKey: 'login',
      },
    }, ],
  },
];
const isLogin = function () {
  return ApiService.isLogin();
};
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
export default router;